// useAvailableHeight.js
import { useEffect, useState } from 'react';

const useAvailableHeight = (ref, bottomSpacing = 20) => {
    const [height, setHeight] = useState(400); // fallback height

    useEffect(() => {
        const updateHeight = () => {
            if (ref.current) {
                const topOffset = ref.current.getBoundingClientRect().top;
                const available = window.innerHeight - topOffset - bottomSpacing;
                setHeight(available);
            }
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, [ref, bottomSpacing]);

    return height;
};

export default useAvailableHeight;
